import React, { ReactNode, useEffect } from 'react';
import { ShopifyAppBridgeProvider } from '../lib/contexts/ShopifyAppBridgeContext';

interface ShopifyLayoutProps {
  children: ReactNode;
  title?: string;
}

/**
 * Layout for Shopify embedded app pages
 * Includes necessary App Bridge initialization via CDN script
 * Excludes site navigation (Navbar/Footer) for embedded iframe context
 */

export default function ShopifyLayout({ children, title = 'Shopify App' }: ShopifyLayoutProps) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    // App Bridge and its meta tag are declared in index.html (must be first <script>, no async).
    // Only inject Polaris here since it has no first-script constraint.
    if (!document.querySelector('script[src*="polaris"]')) {
      const s = document.createElement('script');
      s.src = 'https://cdn.shopify.com/shopifycloud/polaris.js';
      s.async = true;
      document.head.appendChild(s);
    }
  }, []);

  return (
    <>
      <ShopifyAppBridgeProvider>
        <div className="min-h-screen flex flex-col">
          <div className="flex-1 pt-6">
            {children}
          </div>
          <footer className="text-center py-2">
            <span className="text-gray-300 text-[10px] select-none">
              v0.9.1
            </span>
          </footer>
        </div>
      </ShopifyAppBridgeProvider>
    </>
  );
}
